module.exports = __webpack_public_path__ + "img/PL08931.54379e86.png";